























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Typography } from '@/components/atoms';
import CoinsIcon from '@/components/icons/Coins.vue';
import AtSignIcon from '@/components/icons/AtSign.vue';
import ChatIcon from '@/components/icons/Chat.vue';
import LinkIcon from '@/components/icons/Link.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';

export type SocialOverviewFieldProp = {
  icon: 'CoinsIcon' | 'AtSignIcon' | 'ChatIcon' | 'LinkIcon';
  label: string;
};

@Component({
  components: {
    Typography,
    CoinsIcon,
    AtSignIcon,
    ChatIcon,
    LinkIcon,
    FilledButton,
    Checkbox
  }
})
export default class CampaignOverview extends Vue {
  @Prop() socialTitle!: string;
  @Prop() socialDescription!: string;
  @Prop() overviewFields!: SocialOverviewFieldProp[];
  @Prop({ default: false }) isEdit?: boolean;
  @Prop({ default: false }) isActive?: boolean;
}
